<template>
	<div class="basket-list-item py-3">
		<div class="basket-item component-loading with-icon d-flex">
			<div class="image-container">
				<a :href="wishListItem | itemURL">
					<img class="d-block mw-100 mh-100" v-if="image" :src="image" :title="wishListItem | itemName">
				</a>
			</div>

			<div class="meta-container-wrapper">
				<div class="meta-container-wrapper-inner mb-2">
					<div class="meta-container">
						<div class="position-relative w-100">
							<a  :href="wishListItem | itemURL">
								<div class="basket-item-name text-primary text-appearance small font-weight-bold text-break">
									{{ wishListItem.texts.name2 }}
								</div>

								<div class="basket-item-description">
									{{ wishListItem.texts.name3 }}
								</div>
							</a>

							<div class="basket-item-bottom">
								<div class="basket-item-number">
									{{ $translate("HoferAntikschmuck::Template.singleItemObjectNr") }}: {{ wishListItem.variation.number }}
								</div>

								<div class="basket-item-delete" @click="removeItem()" data-testing="remove-wlist-item">
									<svg width="16" height="16" fill="currentColor">
										<use xlink:href="#cancel" />
									</svg>
									{{ $translate("Ceres::Template.basketDelete") }}
								</div>
							</div>
						</div>
					</div>
					<div class="basket-item-container-right">
						<div class="basket-item-price-box">
							<div class="item-total-price">
								{{ quantity * unitPrice | currency }}
							</div>

							<add-to-basket
								:variation-id="wishListItem.variation.id"
								:is-salable="!!wishListItem.filter && wishListItem.filter.isSalable"
								:has-children="!!wishListItem.filter && wishListItem.filter.hasActiveChildren"
								:interval-quantity="wishListItem.variation.intervalOrderQuantity || 1"
								:minimum-quantity="wishListItem.variation.minimumOrderQuantity"
								:maximum-quantity="!!wishListItem.variation.maximumOrderQuantity && wishListItem.variation.maximumOrderQuantity > 0 ? wishListItem.variation.maximumOrderQuantity : null"
								:order-properties="wishListItem.properties.filter((prop) => prop.property.isOderProperty)"
								:has-order-properties="wishListItem.hasOrderProperties"
								:has-required-order-property="wishListItem.hasRequiredOrderProperty"
								:use-large-scale="false"
								:show-quantity="false"
								:item-url="wishListItem | itemURL"
								:has-price="wishListItem | hasItemDefaultPrice"
								:is-wish-list="true"
								:prop-quantity="quantity"
								:item-type="wishListItem.item.itemType">
							</add-to-basket>

						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import NotificationService from "ceres/app/services/NotificationService";
import { mapState, mapActions } from "vuex";
import { isNullOrUndefined } from "ceres/app/helper/utils";

export default {

	name: "wish-list-item",

	props:
		{
			imageAccessor:
				{
					type: String,
					default: "urlPreview"
				},
			itemDetailsData:
				{
					type: Array,
					default: () => ["wishListItem.variation.availability"]
				},
			wishListItemRaw: Object
		},

	data()
	{
		return {
			wishListItem: null,
			quantity: 1
		};
	},

	computed:
		{
			image()
			{
				const itemImages = this.$options.filters.itemImages(this.wishListItem.images, this.imageAccessor);

				return this.$options.filters.itemImage(itemImages);
			},

			unitPrice()
			{
				if (!isNullOrUndefined(this.wishListItem.prices.specialOffer))
				{
					return this.wishListItem.prices.specialOffer.unitPrice.value;
				}

				return this.wishListItem.prices.default.unitPrice.value;
			},

			basePrice()
			{
				if (!isNullOrUndefined(this.wishListItem.prices.specialOffer))
				{
					return this.wishListItem.prices.specialOffer.basePrice;
				}

				return this.wishListItem.prices.default.basePrice;
			},

			...mapState({
				wishListItems: state => state.wishList.wishListItems
			})
		},

	created()
	{
		this.wishListItem = this.wishListItemRaw.data;
	},

	methods:
		{
			isDataFieldVisible(value)
			{
				return this.itemDetailsData.includes(value);
			},

			removeItem()
			{
				const item =
					{
						id: this.wishListItem.variation.id,
						wishListItem: this.wishListItemRaw,
						index: this.wishListItems.findIndex(item => item.id === this.wishListItemRaw.id)
					};

				this.removeWishListItem(item)
					.then(() => NotificationService.success(
						this.$translate("Ceres::Template.wishListRemoved")
					).closeAfter(3000));
			},

			...mapActions([
				"removeWishListItem"
			])
		}
}
</script>
